import { Button } from "@/components/ui/button";

/**
 * The offset pager shared by every server-paged queue in this module.
 *
 * It is a module component rather than the shell `DataTable`'s pager because
 * these views are card lists, not tables — but the contract is the same one the
 * shell enforces: the SERVER's total, never the length of what was fetched.
 */
export function QueuePager({
  offset,
  pageSize,
  total,
  busy = false,
  onOffset,
}: {
  offset: number;
  pageSize: number;
  total: number;
  busy?: boolean;
  onOffset: (offset: number) => void;
}) {
  if (total <= pageSize) return null;
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + pageSize, total);
  return (
    <div className="flex items-center justify-between text-[13px] font-medium text-muted-foreground">
      <span className="tabular-nums">
        {from}&ndash;{to} of {total.toLocaleString("en-US")}
      </span>
      <span className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={offset === 0 || busy}
          onClick={() => onOffset(Math.max(0, offset - pageSize))}
        >
          Previous
        </Button>
        <Button variant="outline" size="sm" disabled={to >= total || busy} onClick={() => onOffset(offset + pageSize)}>
          Next
        </Button>
      </span>
    </div>
  );
}
